import React from 'react';
import { StarIcon } from 'lucide-react';
import { casinos } from '../../data/casinos';
import { countSlotsForCasino } from '../../utils/slots';
import { RealMoneyButton } from '../RealMoneyButton';
export function CasinoInlineOffer() {
  const casino = casinos[0];
  return <aside aria-label="Advertentie" className="flex flex-col gap-4 border-y border-oranje/30 bg-oranje-soft px-4 py-5 sm:px-6 md:flex-row md:items-center md:justify-between" data-id="element-161" data-mp="gwdktwkv12dx">
      <div className="flex items-center gap-4" data-id="element-162" data-mp="3kd3z0yqlilqp">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl font-serif text-lg font-semibold text-white" style={{
        backgroundColor: casino.color
      }} aria-hidden="true" data-id="element-163" data-mp="3kdvhr8z3gozk">
          {casino.initials}
        </span>
        <div data-id="element-164" data-mp="14mr6948xw2zj">
          <p className="text-sm text-muted" data-id="element-165" data-mp="14kwm3s5hsewi">
            Alle Top 10-slots onder één dak ·{' '}
            <span className="inline-flex items-center gap-0.5 font-medium text-ink" data-id="element-166" data-mp="19jzrxetaqp5j">
              <StarIcon className="h-3.5 w-3.5 fill-oranje text-oranje" aria-hidden="true" data-id="element-167" data-mp="126ne96cj975t" />
              {casino.rating}
            </span>
          </p>
          <p className="font-serif text-lg font-semibold" data-id="element-168" data-mp="y2nxqnr968cg">
            {casino.name}: {casino.bonus}{' '}
            <span className="font-sans text-sm font-normal text-muted" data-id="element-169" data-mp="t7iho5kj7nwa">{casino.bonusDetail}</span>
          </p>
          <p className="text-[11px] text-muted" data-id="element-170" data-mp="j7hto6bpwjlr">
            Advertentie · 18+ · {countSlotsForCasino(casino)} van 30 slots · Voorwaarden van toepassing
          </p>
        </div>
      </div>
      <RealMoneyButton casino={casino} label="Claim bonus" className="shrink-0" data-id="element-171" data-mp="eeyith4f02kn" />
    </aside>;
}